module.exports = __webpack_public_path__ + "static/media/julesMapBook.1aa64638.png";